<template>
  <div class="main">
    <el-dialog
      :title="openData.title"
      :visible.sync="openData.state"
      :close-on-click-modal="false"
      width="70%"
      class="dialog_container"
      @close="dialogVisibleClone"
    >
      <div class="dialog_content">
        <el-form
          label-position="left"
          label-width="180px"
          ref="formData"
          :model="formData"
          :rules="formDataRules"
        >
          <el-row>
            <el-col :span="11">
              <el-form-item label="机构名称：" prop="organizationName">
                <el-input
                  :disabled="openData.title == '详情'"
                  v-model.trim="formData.organizationName"
                  placeholder="请输入机构名称"
                ></el-input>
              </el-form-item>
              <el-form-item label="机构负责人：" prop="principal">
                <el-input
                  :disabled="openData.title == '详情'"
                  v-model.trim="formData.principal"
                  placeholder="请输入机构负责人"
                ></el-input>
              </el-form-item>
              <el-form-item label="联系电话：" prop="telphone">
                <el-input
                  :disabled="openData.title == '详情'"
                  v-model.number="formData.telphone"
                  :maxlength="11"
                  placeholder="请输入联系电话"
                ></el-input>
              </el-form-item>
              <el-form-item label="统一社会信用代码：" prop="code">
                <el-input
                  :disabled="openData.title == '详情'"
                  v-model.trim="formData.code"
                  placeholder="请输入统一社会信用代码"
                ></el-input>
              </el-form-item>
              <el-form-item label="机构等级：" prop="organizationLeval">
                <el-radio-group
                  :disabled="openData.title == '详情'"
                  v-model="formData.organizationLeval"
                >
                  <el-radio :label="1">A</el-radio>
                  <el-radio :label="2">AA</el-radio>
                  <el-radio :label="3">AAA</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="是否设医疗机构：" prop="medicalCareFlag">
                <el-radio-group
                  :disabled="openData.title == '详情'"
                  v-model="formData.medicalCareFlag"
                >
                  <el-radio :label="1">是</el-radio>
                  <el-radio :label="0">否</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
            <el-col :span="11" :offset="1">
              <el-form-item label="站点类型：" prop="serviceStationType">
                <el-radio-group
                  :disabled="openData.title == '详情'"
                  v-model="formData.serviceStationType"
                >
                  <el-radio :label="1">服务中心</el-radio>
                  <el-radio :label="2">机构</el-radio>
                  <el-radio :label="3">呼叫中心</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="法人代表：" prop="legalRepresentative">
                <el-input
                  :disabled="openData.title == '详情'"
                  v-model.trim="formData.legalRepresentative"
                  placeholder="请输入法人代表"
                ></el-input>
              </el-form-item>

              <el-form-item label="联系电话：" prop="phone">
                <el-input
                  :maxlength="11"
                  :disabled="openData.title == '详情'"
                  v-model.number="formData.phone"
                  placeholder="请输入联系电话"
                ></el-input>
              </el-form-item>
              <el-form-item label="养老机构许可证：" prop="licence">
                <el-input
                  :disabled="openData.title == '详情'"
                  v-model.trim="formData.licence"
                  placeholder="请输入养老机构许可证"
                ></el-input>
              </el-form-item>
              <el-form-item label="卫生许可证：" prop="licenceFlag">
                <el-radio-group
                  v-model="formData.licenceFlag"
                  :disabled="openData.title == '详情'"
                >
                  <el-radio :label="1">有</el-radio>
                  <el-radio :label="0">无</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="对外服务电话：" prop="servicePhone">
                <el-input
                  :maxlength="11"
                  :disabled="openData.title == '详情'"
                  v-model.number="formData.servicePhone"
                  placeholder="请输入对外服务电话"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-form-item label="医疗服务方式：" prop="medicalCareWay">
            <el-radio-group
              v-model="formData.medicalCareWay"
              :disabled="openData.title == '详情'"
            >
              <el-radio :label="1">自办医院</el-radio>
              <el-radio :label="2">护理站</el-radio>
              <el-radio :label="3">医务室</el-radio>
              <el-radio :label="4">医院</el-radio>
              <el-radio :label="5">乡镇卫生院</el-radio>
              <el-radio :label="6">村（社区）卫生机构（中心）</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="健康一体机：">
            <el-select
              v-model="formData.deviceId"
              placeholder="请选择"
              style="width: 37%"
              :disabled="openData.title == '详情'"
            >
              <el-option
                :label="item.venConding"
                :value="item.venConding"
                v-for="(item, index) in equipList"
                :key="index"
              ></el-option>
            </el-select>
          </el-form-item>

          <el-row>
            <el-col :span="11">
              <el-form-item
                label="是否具备医保定点资格："
                prop="medicalPointFlag"
              >
                <el-radio-group
                  :disabled="openData.title == '详情'"
                  v-model="formData.medicalPointFlag"
                >
                  <el-radio :label="1">有</el-radio>
                  <el-radio :label="0">无</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="营业执照：" prop="businessLicense">
                <el-upload
                  class="upload-demo"
                  :disabled="openData.title == '详情'"
                  :action="baseUrl"
                  :on-success="licenseSuccess"
                  :show-file-list="false"
                  :on-remove="handleRemove"
                  :before-remove="beforeRemove"
                  multiple
                  :limit="3"
                  :on-exceed="handleExceed"
                >
                  <div v-if="openData.title != '详情'">
                    <el-button size="small" type="primary">点击上传</el-button>
                  </div>
                  <div v-if="formData.businessLicense.length">
                    <div>
                      <p
                        class="uploadList"
                        v-for="(item, index) in formData.businessLicense"
                        :key="index"
                      >
                        <img :src="item" class="uplogImg" alt="" srcset="" />
                      </p>
                    </div>
                  </div>
                </el-upload>
              </el-form-item>
            </el-col>
            <el-col :span="11" :offset="1">
              <el-form-item label="机构用房来源" prop="housResource">
                <el-radio-group
                  v-model="formData.housResource"
                  :disabled="openData.title == '详情'"
                >
                  <el-radio label="1">自有产权</el-radio>
                  <el-radio label="2">租赁</el-radio>
                  <el-radio label="3">合作使用</el-radio>
                  <el-radio label="4">其他</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="机构图片：" prop="photo">
                <el-upload
                  class="upload-demo"
                  :action="baseUrl"
                  :disabled="openData.title == '详情'"
                  :on-success="photoSuccess"
                  :show-file-list="false"
                  :on-remove="handleRemove"
                  :before-remove="beforeRemove"
                  multiple
                  :limit="3"
                  :on-exceed="handleExceed"
                >
                  <div v-if="openData.title != '详情'">
                    <el-button size="small" type="primary">点击上传</el-button>
                  </div>
                  <div v-if="formData.photo.length">
                    <div class="uploadList">
                      <p v-for="(item, index) in formData.photo" :key="index">
                        <img :src="item" class="uplogImg" alt="" srcset="" />
                      </p>
                    </div>
                  </div>
                </el-upload>
              </el-form-item>
            </el-col>
          </el-row>
          <el-form-item label="简介：" prop="introduction">
            <quillEditor
              style="width: 100%"
              :disabled="openData.title == '查看' ? 'readonly' : false"
              v-model="formData.introduction"
            >
            </quillEditor>
          </el-form-item>
          <el-form-item label="机构地点：">
            <el-button
              type="success"
              class="button"
              size="mmedium"
              style="margin-bottom: 25px"
              @click="mapTap"
              >显示位置</el-button
            >
            <div v-show="showMap">
              <el-row>
                <el-col :span="4">
                  <el-form-item>
                    <el-select
                      v-model="formData.provinceId"
                      placeholder="请选择省"
                      @change="handleProvince"
                      :disabled="
                        normalInfo.orgLevel == 1 ||
                        normalInfo.orgLevel == 2 ||
                        normalInfo.orgLevel == 3 ||
                        normalInfo.orgLevel == 4 ||
                        normalInfo.orgLevel == 5 ||
                        openData.title == '详情'
                      "
                      style="width: 100%"
                      ref="selectShengChange"
                    >
                      <el-option
                        v-for="(item, index) in provinceList"
                        :key="index"
                        :label="item.name"
                        :value="item.adcode"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="4" :offset="1">
                  <el-select
                    v-model="formData.cityId"
                    placeholder="请选择市"
                    :disabled="
                      normalInfo.orgLevel == 2 ||
                      normalInfo.orgLevel == 3 ||
                      normalInfo.orgLevel == 4 ||
                      normalInfo.orgLevel == 5 ||
                      openData.title == '详情'
                    "
                    @change="handleCity"
                    ref="selectShiChange"
                    style="width: 100%"
                  >
                    <el-option
                      v-for="(item, index) in cityList"
                      :key="index"
                      :label="item.name"
                      :value="item.adcode"
                    >
                    </el-option>
                  </el-select>
                </el-col>
                <el-col :span="4" :offset="1">
                  <el-select
                    v-model="formData.zoneId"
                    placeholder="请选择区"
                    @change="handleArea"
                    :disabled="
                      normalInfo.orgLevel == 3 ||
                      normalInfo.orgLevel == 4 ||
                      normalInfo.orgLevel == 5 ||
                      openData.title == '详情'
                    "
                    ref="selectQuChange"
                    style="width: 100%"
                  >
                    <el-option
                      v-for="(item, index) in areaList"
                      :key="index"
                      :label="item.name"
                      :value="item.adcode"
                    >
                    </el-option>
                  </el-select>
                </el-col>
                <el-col :span="4" :offset="1">
                  <el-select
                    v-model="formData.streetId"
                    placeholder="请选择街道"
                    :disabled="
                      normalInfo.orgLevel == 4 ||
                      normalInfo.orgLevel == 5 ||
                      openData.title == '详情'
                    "
                    @change="streetChange"
                    ref="selectJiedaoChange"
                  >
                    <el-option
                      v-for="(item, index) in streetList"
                      :key="index"
                      :label="item.addName"
                      :value="item.addCode"
                    >
                    </el-option>
                  </el-select>
                </el-col>
                <el-col :span="4" :offset="1">
                  <el-select
                    v-model="formData.shequId"
                    placeholder="请选择社区"
                    :disabled="
                      normalInfo.orgLevel == 5 || openData.title == '详情'
                    "
                    ref="selectShequChange"
                    @change="handleCommunityChange"
                  >
                    <el-option
                      v-for="item in communityList"
                      :key="item.id"
                      :label="item.address"
                      :value="item.id"
                    >
                    </el-option>
                  </el-select>
                </el-col>
              </el-row>
              <input
                style="margin: 15px 0"
                v-model.trim="formData.address"
                :disabled="openData.title == '详情'"
                id="tipinput"
                class="el-input__inner"
                :class="openData.title == '详情' ? 'innerCur' : ''"
                @focus="getMap('tipinput')"
                placeholder="请输入关键字"
                autocomplete="off"
              />
              <div class="map_container">
                <div
                  class="map_right"
                  id="container"
                  style="width: 100%; height: 300px"
                ></div>
              </div>
            </div>
          </el-form-item>
        </el-form>
      </div>
      <div
        slot="footer"
        class="dialog-footer dialog-footer-btn"
        v-if="openData.title != '详情'"
      >
        <el-button type="primary" @click="handleSubmit">确 定</el-button>
        <el-button @click="dialogVisibleClone">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import baseURL from "@/api/baseURL"
import "quill/dist/quill.core.css"
import "quill/dist/quill.snow.css"
import "quill/dist/quill.bubble.css"
import { quillEditor } from "vue-quill-editor"
export default {
  props: ["openData"],
  components: {
    quillEditor,
  },
  data() {
    var chekPhone = (rule, value, callback) => {
      let validatePhone = /^1[3|4|5|6|7|8|9]\d{9}$/
      if (!validatePhone.test(value)) {
        return callback(new Error("手机号格式错误"))
      }
      callback()
    }
    return {
      photoFile: [],
      licenseList: [],
      showMap: false,
      baseURL: "",
      imageUrl: "",
      formData: {
        organizationName: "",
        serviceStationType: 1,
        principal: "",
        telphone: "",
        legalRepresentative: "",
        phone: "",
        organizationLeval: 1,
        licenceFlag: 1,
        code: "",
        licence: "",
        medicalCareFlag: 1,
        medicalPointFlag: 1,
        servicePhone: "",
        medicalCareWay: 1,
        housResource: 1,
        businessLicense: [],
        introduction: "",
        photo: [],
        longitude: "",
        latitude: "",
        provinceId: "", //省
        cityId: "", //市
        zoneId: "", //区
        streetId: "", //街道
        shequId: "", //社区
        address: "",
      },
      orgList: [],
      provinceList: [], //省列表
      cityList: [], //市列表
      areaList: [], //区列表
      streetList: [], //街道列表
      communityList: [], //社区列表
      myMap: null,
      isMap: true,
      polygons: [],
      polygon: [],
      marker: null, //地图标记点
      recMap: null,
      recIsMap: true,
      recPolygons: [],
      recPolygon: [],
      recMarker: null, //地图标记点
      formDataRules: {
        medicalCareWay: [
          {
            required: true,
            message: "服务方式不能为空",
            trigger: "blur",
          },
        ],
        //表格表单验证
        medicalCareFlag: [
          {
            required: true,
            message: "是否设医疗机构不能为空",
            trigger: "blur",
          },
        ],
        organizationName: [
          {
            required: true,
            message: "机构名称不能为空",
            trigger: "blur",
          },
        ],
        serviceStationType: [
          {
            required: true,
            message: "服务类型不能为空",
            trigger: "blur",
          },
        ],
        medicalCareWay: [
          {
            required: true,
            message: "服务方式不能为空",
            trigger: "blur",
          },
        ],
        principal: [
          {
            required: true,
            message: "负责人不能为空",
            trigger: "blur",
          },
        ],

        telphone: [
          {
            required: true,
            message: "负责人联系电话不能为空",
            trigger: "blur",
          },
          { validator: chekPhone, trigger: "blur" },
        ],
        legalRepresentative: [
          {
            required: true,
            message: "法人代表不能为空",
            trigger: "blur",
          },
        ],
        phone: [
          {
            required: true,
            message: "法人电话不能为空",
            trigger: "blur",
          },
          { validator: chekPhone, trigger: "blur" },
        ],
        servicePhone: [
          {
            required: true,
            message: "对外服务电话不能为空",
            trigger: "blur",
          },
          { validator: chekPhone, trigger: "blur" },
        ],
        medicalPointFlag: [
          {
            required: true,
            message: "医保定点资格不能为空",
            trigger: "blur",
          },
        ],
        code: [
          {
            required: true,
            message: "统一社会信用代码不能为空",
            trigger: "blur",
          },
        ],
        housResource: [
          {
            required: true,
            message: "用房来源不能为空",
            trigger: "blur",
          },
        ],
        licence: [
          {
            required: true,
            message: "养老机构许可证不能为空",
            trigger: "blur",
          },
        ],
        licenceFlag: [
          {
            required: true,
            message: "卫生许可证不能为空",
            trigger: "blur",
          },
        ],
        // photo: [
        //     {
        //         required: true,
        //         message: "机构照片不能为空",
        //         trigger: "blur",
        //         type: "array",
        //     },
        // ],
        // businessLicense: [
        //     {
        //         required: true,
        //         message: "营业执照不能为空",
        //         trigger: "blur",
        //         type: "array",
        //     },
        // ],
        introduction: [
          {
            required: true,
            message: "卫生许可证不能为空",
            trigger: "blur",
          },
        ],
        organizationLeval: [
          {
            required: true,
            message: "机构等级不能为空",
            trigger: "blur",
          },
        ],
      },
      normalInfo: {},
      equipList: [],
    }
  },
  created() {
    this.baseUrl = baseURL + "/ypt/controller/uploadController/info/uploadPhoto"

    this.formData = {
      organizationName: "",
      serviceStationType: 1,
      principal: "",
      telphone: "",
      legalRepresentative: "",
      phone: "",
      organizationLeval: 1,
      licenceFlag: 1,
      medicalCareFlag: 1,
      code: "",
      licence: "",
      medicalPointFlag: 1,
      servicePhone: "",
      medicalCareWay: 1,
      housResource: 1,
      businessLicense: [],
      introduction: "",
      photo: [],
      provinceId: "", //省
      cityId: "", //市
      zoneId: "", //区
      streetId: "", //街道
      shequId: "", //社区,
      address: "",
      longitude: "",
      latitude: "",
      deviceId: "",
    }
    this.getEquipList()
    this.getProvince()
    if (this.openData.title == "新增") {
    } else {
      this.dataInfos()
    }
    // setTimeout(async () => {
    //     await this.$nextTick(() => this.loadmap())
    // }, 200)
    this.getJoin()
  },
  methods: {
    // 获取组织机构
    getJoin() {
      // console.log(this.$store.state.info)
      this.$http
        .request({
          url: "/rbac/admin/org/info/findOrgById",
          method: "POST",
          data: { id: this.$store.state.info.orgId },
        })
        .then((res) => {
          if (res.code == 200) {
            // this.getProvince()
            this.normalInfo = res.content
            if (this.openData.title == "新增") {
              this.changeFirst()
            }
          } else {
            this.$message.error(res.message)
          }
        })
    },
    getEquipList() {
      this.$http
        .request({
          url: "/ypt/admin/equVendor/info/findData",
          method: "POST",
          data: {},
        })
        .then((res) => {
          // console.log(res)
          if (res.code == 200 && res.content) {
            this.equipList = res.content
          } else {
            this.equipList = []
          }
        })
    },
    async changeFirst() {
      // console.log(
      //     this.normalInfo,
      //     "机构信息 normalInfo.orgLevel",
      //     this.provinceList
      // )
      let province = await this.getDistricts()
      this.provinceList = province.districtList
      if (this.normalInfo.provinceId == 0) {
        this.normalInfo.provinceId = ""
      } else {
        this.normalInfo.provinceId = String(this.normalInfo.provinceId)
        let cityList = await this.getDistricts(this.normalInfo.provinceId)
        this.cityList = cityList.districtList
        // console.log("城市", this.cityList)
      }
      if (this.normalInfo.cityId) {
        this.normalInfo.cityId = String(this.normalInfo.cityId)
        let areaList = await this.getDistricts(this.normalInfo.cityId)
        this.areaList = areaList.districtList
      } else {
        this.normalInfo.cityId = ""
      }

      if (this.normalInfo.areaId) {
        this.normalInfo.areaId = String(this.normalInfo.areaId)
        let streetList = await this.getStreetList(this.normalInfo.areaId)
        this.streetList = streetList
      } else {
        this.normalInfo.areaId = ""
      }
      if (this.normalInfo.streetId) {
        this.normalInfo.streetId = String(this.normalInfo.streetId)
        let communityList = await this.getCommityList(this.normalInfo.streetId)
        this.communityList = communityList
      } else {
        this.normalInfo.streetId = ""
      }
      if (this.normalInfo.orgLevel == 1 || this.normalInfo.orgLevel == 0) {
        this.provinceList.forEach((item) => {
          if (item.adcode == this.normalInfo.provinceId) {
            this.formData.latitude = item.center.lat
            this.formData.longitude = item.center.lng
          }
        })
      } else if (this.normalInfo.orgLevel == 2) {
        this.cityList.forEach((item) => {
          if (item.adcode == this.normalInfo.cityId) {
            this.formData.latitude = item.center.lat
            this.formData.longitude = item.center.lng
          }
        })
      } else if (this.normalInfo.orgLevel == 3) {
        this.areaList.forEach((item) => {
          if (item.adcode == this.normalInfo.areaId) {
            this.formData.latitude = item.center.lat
            this.formData.longitude = item.center.lng
          }
        })
      } else if (
        this.normalInfo.orgLevel == 4 ||
        this.normalInfo.orgLevel == 5
      ) {
        this.streetList.forEach((item, index) => {
          if (item.addCode == this.normalInfo.streetId) {
            this.formData.latitude = item.latitude
            this.formData.longitude = item.longitude
          }
        })
      }

      if (this.normalInfo.communityId) {
        this.normalInfo.communityId = Number(this.normalInfo.communityId)
      } else {
        this.normalInfo.communityId = ""
      }
      this.formData.provinceId = this.normalInfo.provinceId
      this.formData.cityId = this.normalInfo.cityId
      this.formData.zoneId = this.normalInfo.areaId
      this.formData.streetId = this.normalInfo.streetId
      this.formData.shequId = Number(this.normalInfo.communityId)
      // console.log(this.formData.shequId, "2121")
      this.$forceUpdate()
      // console.log(this.normalInfo, "机构信息",this.)
    },
    // 打点
    potintMap() {
      const self = this
      try {
        self.myMap.remove(self.marker)
      } catch (err) {
        console.log(err)
      }
      self.marker = new AMap.Marker({
        icon: "http://webapi.amap.com/theme/v1.3/markers/n/mark_b.png",
        position: [
          Number(self.formData.longitude),
          Number(self.formData.latitude),
        ],
      })
      self.myMap.add(self.marker)
      self.myMap.setFitView()
    },
    // 地图打点
    getMap(input) {
      const self = this
      const autoOptions = {
        city: self.formData.zoneId,
        citylimit: true,
        input: input,
      }
      // alert(input)
      const auto = new AMap.Autocomplete(autoOptions)
      //构造地点查询类
      AMap.event.addListener(auto, "select", (e) => {
        self.formData.address = e.poi.name
        self.formData.longitude = e.poi.location.lng
        self.formData.latitude = e.poi.location.lat
        self.loadmap("container")
        setTimeout(() => {
          self.potintMap()
        }, 500)
      })
    },
    async streetChange(val) {
      this.formData.shequId = ""
      let communityList = await this.getCommityList(val)
      console.log(communityList, "社区列表")
      this.communityList = communityList
      this.joinAddress()
    },
    //街道地址列表
    getStreetList(val) {
      let self = this
      return new Promise((resolve, reject) => {
        self.$http
          .request({
            url: "/ypt/admin/addressYpe/info/findList",
            method: "POST",
            data: {
              parentId: val,
              pageNo: 1,
              pageSize: -1,
            },
          })
          .then((res) => {
            if (res.code == 200) {
              if (!res.content) {
                resolve([])
                return
              }
              this.streetList = res.content.list
              resolve(res.content.list)
            } else {
              resolve([])
            }
          })
      }).catch((err) => {
        console.log(err)
      })
    },
    // 社区地址列表
    getCommityList(val) {
      let self = this
      return new Promise((resolve, reject) => {
        self.$http
          .request({
            url: "/ypt/admin/standardAddress/info/StandardAddressTree",
            method: "POST",
            data: {
              jiedaoId: val,
            },
          })
          .then((res) => {
            if (res.code == 200) {
              if (!res.content) {
                resolve([])
                return
              }
              resolve(res.content)
            } else {
              resolve([])
            }
          })
      }).catch((err) => {
        console.log(err)
      })
    },
    handleCommunityChange(val) {
      this.$nextTick(() => {
        this.$forceUpdate()
        this.joinAddress()
      })
    },
    //获取地址
    getDistricts(name = "中国", params = null) {
      let self = this
      return new Promise((resolve, reject) => {
        var opts = {
          subdistrict: 1, //返回下一级行政区
          extensions: "all",
          showbiz: false, //最后一级返回街道信息
        }
        let district = new AMap.DistrictSearch(opts)
        let geocoder = new AMap.Geocoder({
          city: "", //城市设为北京，默认：“全国”
          radius: 1000, //范围，默认：500
        })
        try {
          self.myMap.remove(self.marker)
        } catch (err) {
          console.log(err)
        }

        self.marker = new AMap.Marker()
        district.search(name, (status, result) => {
          if (status == "complete") {
            resolve(result.districtList[0])
            if (this.isMap) {
              this.isMap = false
              return
            }
            let bounds = result.districtList[0].boundaries
            self.polygon = null
          }
        })
      }).catch((err) => {
        console.log(err)
      })
    },
    licenseSuccess(res, file) {
      this.formData.businessLicense.push(res.content)
    },
    delLicense(index) {
      this.formData.businessLicense.splice(index, 1)
    },
    photoSuccess(res, file) {
      this.formData.photo.push(res.content)
    },
    // 显示位置
    mapTap() {
      this.showMap = !this.showMap
      if (this.showMap == true) {
        this.loadmap("container")
        setTimeout(() => {
          this.potintMap()
        }, 500)
      }
    },
    handleRemove(file, fileList) {
      // console.log(file, fileList)
    },
    handleExceed(files, fileList) {
      this.$message.warning(
        `当前限制选择 3 个文件，本次选择了 ${files.length} 个文件，共选择了 ${
          files.length + fileList.length
        } 个文件`
      )
    },
    beforeRemove(file, fileList) {
      return this.$confirm(`确定移除 ${file.name}？`)
    },
    // 详情页信息
    dataInfos() {
      const self = this
      let params = {
        id: self.openData.id,
      }
      this.$http
        .request({
          url: "/ypt/admin/homeCare/info/get",
          method: "POST",
          data: params,
        })
        .then(async (res) => {
          if (res.code == 200) {
            let jsonTemp = { ...res.content }
            self.formData.id = jsonTemp.id
            self.formData.organizationName = jsonTemp.organizationName
            self.formData.serviceStationType = jsonTemp.serviceStationType
            self.formData.medicalCareFlag = jsonTemp.medicalCareFlag
            self.formData.principal = jsonTemp.principal
            self.formData.telphone = jsonTemp.telphone
            self.formData.legalRepresentative = jsonTemp.legalRepresentative
            self.formData.phone = jsonTemp.phone
            self.formData.deviceId = jsonTemp.deviceId
            self.formData.organizationLeval = jsonTemp.organizationLeval
            self.formData.licenceFlag = jsonTemp.licenceFlag
            self.formData.code = jsonTemp.code
            self.formData.licence = jsonTemp.licence
            self.formData.medicalPointFlag = jsonTemp.medicalPointFlag
            self.formData.servicePhone = jsonTemp.servicePhone
            self.formData.medicalCareWay = Number(jsonTemp.medicalCareWay)
            self.formData.housResource = jsonTemp.housResource
            self.formData.businessLicense = jsonTemp.businessLicense.split(",")
            self.formData.introduction = jsonTemp.introduction
            self.formData.photo = jsonTemp.photo.split(",")
            self.formData.provinceId = String(jsonTemp.provinceId)
            self.formData.cityId = String(jsonTemp.cityId)
            self.formData.address = String(jsonTemp.address)
            self.formData.zoneId = String(jsonTemp.zoneId)
            self.formData.streetId = String(jsonTemp.streetId)
            self.formData.shequId = Number(jsonTemp.shequId)
            if (self.formData.provinceId) {
              let city = await self.getDistricts(self.formData.provinceId)
              self.cityList = city.districtList
            }

            if (self.formData.cityId) {
              let area = await self.getDistricts(self.formData.cityId)
              self.areaList = area.districtList
            }

            if (self.formData.zoneId) {
              let street = await self.getStreetList(self.formData.zoneId)
              self.streetList = street
            }

            if (self.formData.streetId) {
              let communityList = await self.getCommityList(
                self.formData.streetId
              )
              self.communityList = communityList
            }
            self.formData.longitude = jsonTemp.longitude
            self.formData.latitude = jsonTemp.latitude
            if (self.formData.longitude && self.formData.latitude) {
              self.loadmap("container")
              setTimeout(() => {
                self.potintMap()
              }, 500)
            }
          } else {
            this.$message.error(res.message)
          }
        })
    },

    //表格表单提交
    handleSubmit() {
      let self = this

      this.$refs.formData.validate((valid) => {
        if (valid) {
          if (this.openData.title == "新增" || this.openData.title == "编辑") {
            let url = ""

            if (!self.formData.provinceId) {
              self.$message.error("省级地址为必填项，请选择")
              return
            }
            if (!self.formData.cityId) {
              self.$message.error("市级地址为必填项，请选择")
              return
            }
            if (!self.formData.zoneId) {
              self.$message.error("区县级地址为必填项，请选择")
              return
            }
            if (!self.formData.streetId) {
              self.$message.error("街道地址为必填项，请选择")
              return
            }
            if (
              self.formData.shequId === "" ||
              self.formData.shequId === null ||
              self.formData.shequId === undefined
            ) {
              self.$message.error(
                "社区为必填项，请选择,如无对应社区，请地址管理配置"
              )
              return
            }
            if (!self.formData.address) {
              self.$message.error(
                "详细信息为必填项，请在地图的边界内点击选择或手动输入"
              )
              return
            }
            const reg = /<\/?.+?\/?>/g
            this.formData.introduction = this.formData.introduction.replace(
              reg,
              ""
            )
            // console.log(this.formData.introduction)
            delete this.formData.recTime
            let data = { ...self.formData }
            data.photo = data.photo.join(",")
            data.businessLicense = data.businessLicense.join(",")
            url = "/ypt/admin/homeCare/info/save"
            this.$http
              .request({
                url: url,
                method: "POST",
                data: {
                  ...data,
                },
              })
              .then((res) => {
                if (res.code == 200) {
                  this.$message.success(res.message)
                } else {
                  this.$message.error(res.message)
                }
                this.$emit("cancleService", true)
              })
          }
        }
      })
    },

    joinAddress(address = "") {
      let self = this
      self.$nextTick(() => {
        let shengName = this.$refs.selectShengChange.selectedLabel
        let shiName = this.$refs.selectShiChange.selectedLabel
        let quName = this.$refs.selectQuChange.selectedLabel
        let jiedaoName = this.$refs.selectJiedaoChange.selectedLabel
        let shequName = this.$refs.selectShequChange.selectedLabel
        console.log(
          shengName + shiName + quName + jiedaoName + shequName,
          "111"
        )
        if (!address) {
          self.formData.address =
            shengName + shiName + quName + jiedaoName + shequName
        }
        try {
          self.myMap.remove(self.marker)
        } catch (err) {
          console.log(err)
        }
        let geocoder = new AMap.Geocoder({ city: "" })
        self.marker = new AMap.Marker()
        geocoder.getLocation(this.formData.address, function (status, result) {
          if (status === "complete" && result.geocodes.length) {
            let lnglat = result.geocodes[0].location
            self.formData.longitude = lnglat.lng
            self.formData.latitude = lnglat.lat
            self.marker.setPosition(lnglat)
            self.myMap.add(self.marker)
            self.myMap.setFitView(self.marker)
          } else {
            log.error("根据地址查询位置失败")
          }
        })
      })
    },
    //获取地址
    getDistrict(name = "中国", params = null) {
      console.log(name, "444")
      let self = this
      return new Promise((resolve, reject) => {
        var opts = {
          subdistrict: 1, //返回下一级行政区
          extensions: "all",
          showbiz: false, //最后一级返回街道信息
        }
        let district = new AMap.DistrictSearch(opts)
        let geocoder = new AMap.Geocoder({
          city: "", //城市设为北京，默认：“全国”
          radius: 1000, //范围，默认：500
        })
        try {
          self.myMap.remove(self.marker)
        } catch (err) {
          console.log(err)
        }

        self.marker = new AMap.Marker()
        district.search(name, (status, result) => {
          if (status == "complete") {
            resolve(result.districtList[0])
            if (this.isMap) {
              this.isMap = false
              return
            }
            let bounds = result.districtList[0].boundaries
            // console.log(JSON.stringify(bounds), 555)
            self.polygon = null
            if (bounds) {
              try {
                self.myMap.remove(self.polygons)
              } catch (error) {
                console.log("移除地图编辑出错了")
              }
              self.polygons = []
              for (let i = 0, l = bounds.length; i < l; i++) {
                self.polygon = new AMap.Polygon({
                  map: self.myMap,
                  strokeWeight: 1,
                  strokeColor: "#0091ea",
                  fillColor: "#80d8ff",
                  fillOpacity: 0.4,
                  path: bounds[i],
                })
                self.polygons.push(self.polygon)
                if (!params) {
                  self.polygon.on("click", function (e) {
                    let lnglat = e.lnglat
                    self.myMap.add(self.marker)
                    self.marker.setPosition(lnglat)
                    geocoder.getAddress(lnglat, function (status, result) {
                      if (status === "complete" && result.regeocode) {
                        var address = result.regeocode.formattedAddress
                        self.formData.address = address
                        self.formData.longitude = lnglat.lng
                        self.formData.latitude = lnglat.lat
                      } else {
                        console.error("根据经纬度查询地址失败")
                      }
                    })
                  })
                  self.myMap.add(self.polygons)
                  self.myMap.setFitView() //地图自适应
                } else {
                  if (params.longitude && params.latitude) {
                    self.myMap.add(self.marker)
                    self.marker.setPosition([params.longitude, params.latitude])
                    self.myMap.setFitView(self.marker)
                    self.myMap.setZoom(11)
                  }
                }
              }
            }
          }
        })
      }).catch((err) => {
        console.log(err)
      })
    },
    //获取省级
    async getProvince() {
      this.provinceList = []
      this.cityList = []
      this.areaList = []
      this.streetList = []
      let province = await this.getDistrict()
      this.provinceList = province.districtList
    },
    //  省级地址选择发生改变
    async handleProvince(val) {
      this.cityList = []
      this.areaList = []
      this.streetList = []
      this.communityList = []
      this.formData.cityId = ""
      this.formData.zoneId = ""
      this.formData.streetId = ""
      this.formData.shequId = ""
      this.formData.address = ""
      let city = await this.getDistrict(val)
      this.cityList = city.districtList
      this.joinAddress()
    },
    //市级地址发生改变
    async handleCity(val) {
      this.areaList = []
      this.streetList = []
      this.communityList = []
      this.formData.zoneId = ""
      this.formData.streetId = ""
      this.formData.shequId = ""
      this.formData.address = ""
      let area = await this.getDistrict(val)
      this.areaList = area.districtList
      this.joinAddress()
    },
    //县区级地址发生改变
    async handleArea(val) {
      this.streetList = []
      this.communityList = []
      this.formData.streetId = ""
      this.formData.shequId = ""
      this.formData.address = ""
      // val = val.replace(/.$/, "");
      let street = await this.getStreetList(val)
      this.streetList = street
      this.joinAddress()
    },

    //加载地图
    loadmap() {
      let self = this
      return new Promise((resolve, reject) => {
        self.myMap = new AMap.Map("container", {
          resizeEnable: true,
          zoom: 18,
        })
        resolve()
      })
    },
    // 关闭人员信息
    dialogVisibleClone() {
      // this.openData.state=false;
      this.$emit("cancleService", false)
    },
  },
}
</script>
<style lang="less" scoped>
.avatar {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  font-size: 28px;
  color: #8c939d;
  width: 200px;
  height: 200px;
  line-height: 200px;
  img {
    width: 200px;
    height: 200px;
    line-height: 200px;
    display: block;
  }
}
/deep/ .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  width: 100%;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  .avatar-uploader .el-upload:hover {
    border-color: #409eff;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 100%;
    height: 200px;
    line-height: 200px;
    text-align: center;
  }
}
.dialog-footer-btn {
  text-align: center;
}
/deep/.el-upload {
  border: none;
  width: auto;
}
.uplogImg,
.upBoxs {
  width: 120px;
  height: 120px;
}
.upBoxs {
  position: relative;
  margin-right: 10px;
}
.upIcon {
  position: absolute;
  right: 0;
  top: 0;
  cursor: pointer;
  z-index: 20;
}
.uploadList {
  display: flex;
  flex-wrap: wrap;
  p {
    margin-right: 10px;
  }
}
</style>
